const countries = {
  "United States": {
    countrycode: "US",
    provinces: {
      Alabama: "AL",
      Alaska: "AK",
      "American Samoa": "AS",
      Arizona: "AZ",
      Arkansas: "AR",
      California: "CA",
      Colorado: "CO",
      Connecticut: "CT",
      Delaware: "DE",
      "District of Columbia": "DC",
      "Federated States of Micronesia": "FM",
      Florida: "FL",
      Georgia: "GA",
      Guam: "GU",
      Hawaii: "HI",
      Idaho: "ID",
      Illinois: "IL",
      Indiana: "IN",
      Iowa: "IA",
      Kansas: "KS",
      Kentucky: "KY",
      Louisiana: "LA",
      Maine: "ME",
      "Marshall Islands": "MH",
      Maryland: "MD",
      Massachusetts: "MA",
      Michigan: "MI",
      Minnesota: "MN",
      Mississippi: "MS",
      Missouri: "MO",
      Montana: "MT",
      Nebraska: "NE",
      Nevada: "NV",
      "New Hampshire": "NH",
      "New Jersey": "NJ",
      "New Mexico": "NM",
      "New York": "NY",
      "North Carolina": "NC",
      "North Dakota": "ND",
      "Northern Mariana Islands": "MP",
      Ohio: "OH",
      Oklahoma: "OK",
      Oregon: "OR",
      Palau: "PW",
      Pennsylvania: "PA",
      "Puerto Rico": "PR",
      "Rhode Island": "RI",
      "South Carolina": "SC",
      "South Dakota": "SD",
      Tennessee: "TN",
      Texas: "TX",
      Utah: "UT",
      Vermont: "VT",
      Virginia: "VA",
      Washington: "WA",
      "West Virginia": "WV",
      Wisconsin: "WI",
      Wyoming: "WY",
      "Virgin Islands": "VI",
      "Armed Forces Americas": "AA",
      "Armed Forces Europe": "AE",
      "Armed Forces Pacific": "AP",
    },
  },
  Australia: {
    countrycode: "AU",
    provinces: {
      "Australian Capital Territory": "ACT",
      "New South Wales": "NSW",
      "Northern Territory": "NT",
      Queensland: "QLD",
      "South Australia": "SA",
      Tasmania: "TAS",
      Victoria: "VIC",
      "Western Australia": "WA",
    },
  },
  Austria: {
    countrycode: "AT",
  },
  Belgium: {
    countrycode: "BE",
  },
  Canada: {
    countrycode: "CA",
    provinces: {
      Alberta: "AB",
      "British Columbia": "BC",
      Manitoba: "MB",
      "New Brunswick": "NB",
      "Newfoundland and Labrador": "NL",
      "Northwest Territories": "NT",
      "Nova Scotia": "NS",
      Nunavut: "NU",
      Ontario: "ON",
      "Prince Edward Island": "PE",
      Quebec: "QC",
      Saskatchewan: "SK",
      Yukon: "YT",
    },
  },
  "Czech Republic": {
    countrycode: "CZ",
  },
  Denmark: {
    countrycode: "DK",
  },
  Finland: {
    countrycode: "FI",
  },
  France: {
    countrycode: "FR",
  },
  Germany: {
    countrycode: "DE",
  },
  "Hong Kong": {
    countrycode: "HK",
    provinces: {
      "Hong Kong Island": "HK",
      Kowloon: "KL",
      "New Territories": "NT",
    },
  },
  Ireland: {
    countrycode: "IE",
    provinces: {
      Carlow: "CW",
      Cavan: "CN",
      Clare: "CE",
      Cork: "CO",
      Donegal: "DL",
      Dublin: "D",
      Galway: "G",
      Kerry: "KY",
      Kildare: "KE",
      Kilkenny: "KK",
      Laois: "LS",
      Leitrim: "LM",
      Limerick: "LK",
      Longford: "LD",
      Louth: "LH",
      Mayo: "MO",
      Meath: "MH",
      Monaghan: "MN",
      Offaly: "OY",
      Roscommon: "RN",
      Sligo: "SO",
      Tipperary: "TA",
      Waterford: "WD",
      Westmeath: "WH",
      Wexford: "WX",
      Wicklow: "WW",
    },
  },
  Israel: {
    countrycode: "IL",
  },
  Italy: {
    countrycode: "IT",
    provinces: {
      Agrigento: "AG",
      Alessandria: "AL",
      Ancona: "AN",
      Aosta: "AO",
      Arezzo: "AR",
      "Ascoli Piceno": "AP",
      Asti: "AT",
      Avellino: "AV",
      Bari: "BA",
      "Barletta-Andria-Trani": "BT",
      Belluno: "BL",
      Benevento: "BN",
      Bergamo: "BG",
      Biella: "BI",
      Bologna: "BO",
      Bolzano: "BZ",
      Brescia: "BS",
      Brindisi: "BR",
      Cagliari: "CA",
      Caltanissetta: "CL",
      Campobasso: "CB",
      "Carbonia-Iglesias": "CI",
      Caserta: "CE",
      Catania: "CT",
      Catanzaro: "CZ",
      Chieti: "CH",
      Como: "CO",
      Cosenza: "CS",
      Cremona: "CR",
      Crotone: "KR",
      Cuneo: "CN",
      Enna: "EN",
      Fermo: "FM",
      Ferrara: "FE",
      Firenze: "FI",
      Foggia: "FG",
      "Forlì-Cesena": "FC",
      Frosinone: "FR",
      Genova: "GE",
      Gorizia: "GO",
      Grosseto: "GR",
      Imperia: "IM",
      Isernia: "IS",
      "L’Aquila": "AQ",
      "La Spezia": "SP",
      Latina: "LT",
      Lecce: "LE",
      Lecco: "LC",
      Livorno: "LI",
      Lodi: "LO",
      Lucca: "LU",
      Macerata: "MC",
      Mantova: "MN",
      "Massa-Carrara": "MS",
      Matera: "MT",
      "Medio Campidano": "VS",
      Messina: "ME",
      Milano: "MI",
      Modena: "MO",
      "Monza e Brianza": "MB",
      Napoli: "NA",
      Novara: "NO",
      Nuoro: "NU",
      Ogliastra: "OG",
      "Olbia-Tempio": "OT",
      Oristano: "OR",
      Padova: "PD",
      Palermo: "PA",
      Parma: "PR",
      Pavia: "PV",
      Perugia: "PG",
      "Pesaro e Urbino": "PU",
      Pescara: "PE",
      Piacenza: "PC",
      Pisa: "PI",
      Pistoia: "PT",
      Pordenone: "PN",
      Potenza: "PZ",
      Prato: "PO",
      Ragusa: "RG",
      Ravenna: "RA",
      "Reggio Calabria": "RC",
      "Reggio Emilia": "RE",
      Rieti: "RI",
      Rimini: "RN",
      Roma: "RM",
      Rovigo: "RO",
      Salerno: "SA",
      Sassari: "SS",
      Savona: "SV",
      Siena: "SI",
      Siracusa: "SR",
      Sondrio: "SO",
      Taranto: "TA",
      Teramo: "TE",
      Terni: "TR",
      Torino: "TO",
      Trapani: "TP",
      Trento: "TN",
      Treviso: "TV",
      Trieste: "TS",
      Udine: "UD",
      Varese: "VA",
      Venezia: "VE",
      "Verbano-Cusio-Ossola": "VB",
      Vercelli: "VC",
      Verona: "VR",
      "Vibo Valentia": "VV",
      Vicenza: "VI",
      Viterbo: "VT",
    },
  },
  Japan: {
    countrycode: "JP",
    provinces: {
      Hokkaidō: "JP-01",
      Aomori: "JP-02",
      Iwate: "JP-03",
      Miyagi: "JP-04",
      Akita: "JP-05",
      Yamagata: "JP-06",
      Fukushima: "JP-07",
      Ibaraki: "JP-08",
      Tochigi: "JP-09",
      Gunma: "JP-10",
      Saitama: "JP-11",
      Chiba: "JP-12",
      Tōkyō: "JP-13",
      Kanagawa: "JP-14",
      Niigata: "JP-15",
      Toyama: "JP-16",
      Ishikawa: "JP-17",
      Fukui: "JP-18",
      Yamanashi: "JP-19",
      Nagano: "JP-20",
      Gifu: "JP-21",
      Shizuoka: "JP-22",
      Aichi: "JP-23",
      Mie: "JP-24",
      Shiga: "JP-25",
      Kyōto: "JP-26",
      Ōsaka: "JP-27",
      Hyōgo: "JP-28",
      Nara: "JP-29",
      Wakayama: "JP-30",
      Tottori: "JP-31",
      Shimane: "JP-32",
      Okayama: "JP-33",
      Hiroshima: "JP-34",
      Yamaguchi: "JP-35",
      Tokushima: "JP-36",
      Kagawa: "JP-37",
      Ehime: "JP-38",
      Kōchi: "JP-39",
      Fukuoka: "JP-40",
      Saga: "JP-41",
      Nagasaki: "JP-42",
      Kumamoto: "JP-43",
      Ōita: "JP-44",
      Miyazaki: "JP-45",
      Kagoshima: "JP-46",
      Okinawa: "JP-47",
    },
  },
  Malaysia: {
    countrycode: "MY",
    provinces: {
      Johor: "JHR",
      Kedah: "KDH",
      Kelantan: "KTN",
      "Kuala Lumpur": "KUL",
      Labuan: "LBN",
      Melaka: "MLK",
      "Negeri Sembilan": "NSN",
      Pahang: "PHG",
      Penang: "PNG",
      Perak: "PRK",
      Perlis: "PLS",
      Putrajaya: "PJY",
      Sabah: "SBH",
      Sarawak: "SWK",
      Selangor: "SGR",
      Terengganu: "TRG",
    },
  },
  Netherlands: {
    countrycode: "NL",
  },
  "New Zealand": {
    countrycode: "NZ",
    provinces: {
      Auckland: "AUK",
      "Bay of Plenty": "BOP",
      Canterbury: "CAN",
      "Chatham Islands": "CIT",
      Gisborne: "GIS",
      "Hawke’s Bay": "HKB",
      "Manawatu-Wanganui": "MWT",
      Marlborough: "MBH",
      Nelson: "NSN",
      Northland: "NTL",
      Otago: "OTA",
      Southland: "STL",
      Taranaki: "TKI",
      Tasman: "TAS",
      Waikato: "WKO",
      Wellington: "WGN",
      "West Coast": "WTC",
    },
  },
  Norway: {
    countrycode: "NO",
  },
  Poland: {
    countrycode: "PL",
  },
  Portugal: {
    countrycode: "PT",
    provinces: {
      Açores: "PT-20",
      Aveiro: "PT-01",
      Beja: "PT-02",
      Braga: "PT-03",
      Bragança: "PT-04",
      "Castelo Branco": "PT-05",
      Coimbra: "PT-06",
      Évora: "PT-07",
      Faro: "PT-08",
      Guarda: "PT-09",
      Leiria: "PT-10",
      Lisboa: "PT-11",
      Madeira: "PT-30",
      Portalegre: "PT-12",
      Porto: "PT-13",
      Santarém: "PT-14",
      Setúbal: "PT-15",
      "Viana do Castelo": "PT-16",
      "Vila Real": "PT-17",
      Viseu: "PT-18",
    },
  },
  Singapore: {
    countrycode: "SG",
  },
  "South Korea": {
    countrycode: "KR",
    provinces: {
      Busan: "KR-26",
      Chungbuk: "KR-43",
      Chungnam: "KR-44",
      Daegu: "KR-27",
      Daejeon: "KR-30",
      Gangwon: "KR-42",
      Gwangju: "KR-29",
      Gyeongbuk: "KR-47",
      Gyeonggi: "KR-41",
      Gyeongnam: "KR-48",
      Incheon: "KR-28",
      Jeju: "KR-49",
      Jeonbuk: "KR-45",
      Jeonnam: "KR-46",
      Sejong: "KR-50",
      Seoul: "KR-11",
      Ulsan: "KR-31",
    },
  },
  Spain: {
    countrycode: "ES",
    provinces: {
      "A Coruña": "C",
      Álava: "VI",
      Albacete: "AB",
      Alicante: "A",
      Almería: "AL",
      Asturias: "O",
      Ávila: "AV",
      Badajoz: "BA",
      Balears: "PM",
      Barcelona: "B",
      Burgos: "BU",
      Cáceres: "CC",
      Cádiz: "CA",
      Cantabria: "S",
      Castellón: "CS",
      Ceuta: "CE",
      "Ciudad Real": "CR",
      Córdoba: "CO",
      Cuenca: "CU",
      Girona: "GI",
      Granada: "GR",
      Guadalajara: "GU",
      Guipúzcoa: "SS",
      Huelva: "H",
      Huesca: "HU",
      Jaén: "J",
      "La Rioja": "LO",
      "Las Palmas": "GC",
      León: "LE",
      Lleida: "L",
      Lugo: "LU",
      Madrid: "M",
      Málaga: "MA",
      Melilla: "ML",
      Murcia: "MU",
      Navarra: "NA",
      Ourense: "OR",
      Palencia: "P",
      Pontevedra: "PO",
      Salamanca: "SA",
      "Santa Cruz de Tenerife": "TF",
      Segovia: "SG",
      Sevilla: "SE",
      Soria: "SO",
      Tarragona: "T",
      Teruel: "TE",
      Toledo: "TO",
      Valencia: "V",
      Valladolid: "VA",
      Vizcaya: "BI",
      Zamora: "ZA",
      Zaragoza: "Z",
    },
  },
  Sweden: {
    countrycode: "SE",
  },
  Switzerland: {
    countrycode: "CH",
  },
  "United Arab Emirates": {
    countrycode: "AE",
    provinces: {
      "Abu Dhabi": "AZ",
      Ajman: "AJ",
      Dubai: "DU",
      Fujairah: "FU",
      "Ras al-Khaimah": "RK",
      Sharjah: "SH",
      "Umm al-Quwain": "UQ",
    },
  },
  "United Kingdom": {
    countrycode: "GB",
    provinces: {
      "British Forces": "BFP",
      England: "ENG",
      "Northern Ireland": "NIR",
      Scotland: "SCT",
      Wales: "WLS",
    },
  },
};

window.countries = countries;
